import React from "react"
import { useState } from "react"
import styled from "styled-components"
import QABackground from "./QABackground"
import QuestionCard from "./QuestionCard"

export default function Questions({ data, setPage, marks, setMarks }) {
  const [questionNum, setQuestionNum] = useState(1)
  const [Animation, SetAnimation] = useState(false)

  return (
    <Wrapper className={Animation === true && "active"}>
      <BGWrapper>
        <QABackground />
      </BGWrapper>

      {data?.map(({ number, question, type, answers }) => {
        const NextQuestion = () => {
          if (questionNum < data.length) {
            setTimeout(() => setQuestionNum(number + 1), 500)
          }
          if (questionNum === data.length) {
            setTimeout(() => {
              setPage()
            }, 500)
          }
        }

        return (
          questionNum === number && (
            <QuestionCard
              key={number}
              number={number}
              question={question}
              questionNum={questionNum}
              setQuestionNum={setQuestionNum}
              type={type}
              answers={answers}
              marks={marks}
              setMarks={setMarks}
              changeQuestion={NextQuestion}
            />
          )
        )
      })}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  gap: 100px;
  align-items: center;
  justify-content: center;
`

const BGWrapper = styled.div`
  background-color: #000;
  position: fixed;
  overflow: hidden;
  top: 0;
  left: 0;
  width: 100%;
  height: var(--vh);
  z-index: -1;
`
